import { create } from 'zustand';
import { API_BASE_ENCRYPT_KEY, API_BASE_ENUMS, API_BASE_PERMISSION } from 'api/base';

import request from 'request';

const useStore = create((set: any) => ({
  enums: {},
  permission: [],
  fetchSecretKey: () => {
    return request.post(API_BASE_ENCRYPT_KEY).then((res: any) => {
      localStorage.setItem('UUID', res?.data?.encrypt_key);
      return res?.data?.encrypt_key;
    })
  },
  fetchEnums: () => {
    return request.get(API_BASE_ENUMS).then((res: any) => {
      set({ enums: res?.data || {}});
      return res?.data;
    });
  },
  fetchPermission: () => {
    request.get(API_BASE_PERMISSION).then((res: any) => {
      set({ permission: [{
        "name": "首页",
        "key": "/home"
      }, ...(res?.data || [])] });
      return res?.data;
    });
  }
}))

export default useStore;